import { from, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { gqlQuery } from "libs/awsLib";
import { 
  UPLOAD_FILE_REPORT,
  uploadFileReportSuccess,
  uploadFileReportError,
  CREATE_REPORT_V2,
  createReportV2Success,
  createReportV2Error,
} from "redux/actions/customReports";
import { queryUploadFileReport, mutationCreateReportV2 } from "gql/index";
import { alertError } from "redux/reducers/utils";
import { t } from "utils";

export const uploadFileReportEpic = action$ => action$.pipe(
  ofType(UPLOAD_FILE_REPORT),
  mergeMap(({ payload }) => 
    from(gqlQuery(queryUploadFileReport, payload)).pipe(
      map(uploadFileReportSuccess),
      catchError(error => {
        alertError(t("server_error"));
        return of(uploadFileReportError(error));
      })
    )
  )
);

export const createReportV2Epic = action$ => action$.pipe(
  ofType(CREATE_REPORT_V2),
  mergeMap(({ payload }) => 
    from(gqlQuery(mutationCreateReportV2, payload)).pipe(
      map(createReportV2Success),
      catchError(error => {
        alertError(t("server_error"));
        return of(createReportV2Error(error));
      })
    )
  )
);